import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const ServicePage = ({
  title,
  subtitle,
  description,
  image,
  highlights = [],
  techStack = [],
}) => {
  return (
    <main className="service-page">
      <section className="service-page-hero">
        <div className="service-page-copy">
          <span className="snow-section-label">❆ Our Service</span>
          <h1>{title}</h1>
          <p className="service-page-subtitle">{subtitle}</p>
          <p className="service-page-description">{description}</p>
          <div className="service-page-actions">
            <Link to="/" className="service-page-primary">Back Home</Link>
            <Link to="/#contact" className="service-page-secondary">Book a Call</Link>
          </div>
        </div>

        {image && (
          <div className="service-page-visual">
            <img src={image} alt={title} />
          </div>
        )}
      </section>

      {techStack.length > 0 && (
        <section className="service-page-tech">
          <div className="service-page-section-header">
            <span className="snow-section-label">Tech stack</span>
            <h2>Tools and platforms we use</h2>
          </div>
          <div className="service-tech-grid">
            {techStack.map((tech) => (
              <div key={tech.name} className="service-tech-item">
                <img src={tech.img} alt={tech.name} />
                <span>{tech.name}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </main>
  );
};

export default ServicePage;
